import "./Blockquote.scss";
import { RichText } from "@/sections";

export enum BlockquoteVariantEnum {
  LEFTLINE = "left-line",
  BLUEBOX = "blue-box",
  LIGHTBG = "light-bg",
}

export type BlockquoteProps = {
  text: string | React.ReactNode;
  author: string;
  variant?: BlockquoteVariantEnum;
};

export function Blockquote({
  text,
  author,
  variant = BlockquoteVariantEnum.LEFTLINE,
}: BlockquoteProps) {
  return (
    <blockquote className={`styled-blockquote ${variant}`}>
      <RichText description={text} />
      <footer>{author}</footer>
    </blockquote>
  );
}
